export default [
    // {
    //     path: '/',
    //     redirect: '/home', //重定向
    // },
    {
        path: "/",
        name: "home", //首页
        component: () => import('../views/home'),
    },
    {
        path: "/login",
        name: "login", //登录页
        component: () => import('../views/login'),
    },
    {
        path: "/register",
        name: "register", //注册页
        component: () => import('../views/register'),
    },
    {
        path: "/products",
        name: "products", //产品列表页
        component: () => import('../views/products'),
    },
    {
        path: "/detail",
        name: "detail", //产品详情页
        component: () => import('../views/detail'),
    },
    {
        path: "/cart",
        name: "cart", //购物车
        component: () => import('../views/cart'),
    },
    {
        path: "/pay",
        name: "pay", //付款
        meta: {
            requiresAuth: true,
        },
        component: () => import('../views/pay'),
    },
    {
        path: "/paySuccess",
        name: "paySuccess", //付款成功
        meta: {
            // requiresAuth: true,
        },
        component: () => import('../views/paySuccess'),
    },
    {
        path: "/about",
        name: "about", //关于
        component: () => import('../views/bottom/about'),
    },
    {
        path: "/contactUs",
        name: "contactUs", //联系我们
        component: () => import('../views/bottom/contactUs'),
    },
    {
        path: "/returnPolicy",
        name: "returnPolicy", //退货政策
        component: () => import('../views/bottom/returnPolicy'),
    },
    {
        path: "/startReturn",
        name: "startReturn", //报税
        component: () => import('../views/bottom/startReturn'),
    },
    {
        path: "/FAQ",
        name: "FAQ", //FAQ问答
        component: () => import('../views/bottom/faq'),
    },
    {
        path: "/legalPrivacy",
        name: "legalPrivacy", //隐私条款
        component: () => import('../views/bottom/legalPrivacy'),
    },
    {
        path: "/Accessibility",
        name: "Accessibility", //可访问性
        component: () => import('../views/bottom/Accessibility'),
    },
    {
        path: "/shopping",
        name: "shopping", //可访问性
        component: () => import('../views/bottom/shopping'),
    },
    {
        path: "/mine",
        // name: "mine", //个人中心
        meta: {
            requiresAuth: true,
        },
        component: () => import('../views/mine/mine'),
        children: [
            {
                path: '',
                redirect: 'order', //重定向
            },
            {
                path: 'order',
                name: 'order',
                component: () => import('../views/mine/order'),
            },
            {
                path: 'info',
                name: 'info',
                component: () => import('../views/mine/info'),
            },
            {
                path: 'address',
                name: 'address',
                component: () => import('../views/mine/address'),
            }
        ]
    },
    {
        path: "/reset",
        name: "reset", //重置密码
        component: () => import('../views/reset'),
    },
    // {
    //     path: '/',
    //     redirect: '/home', //重定向
    // },
    // {
    //     path: '/home',
    //     name: '',
    //     component: () => import('../views/container'),
    //     children: [
    //         {
    //             path: '',
    //             name: '首页',
    //             component: () => import('../views/home/index'),
    //         },
    //         {
    //             path: 'interactiveMessageDetail',
    //             name: '互动留言详情',
    //             meta: {
    //                 requiresAuth: true,
    //                 title: '互动留言'
    //             },
    //             // redirect: '/none'
    //             component: () => import('../views/home/interactiveMessageDetail'),
    //         },
    //     ]
    // },
]
